module.exports = __webpack_public_path__ + "static/genevamiam-a84305926e77622ebafa8be5cfb92148.png";